var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("notificator", { ref: "notify", attrs: { singular: true } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gfu-grid gfu-grid--gutter gfua-gallery__container",
          attrs: { "data-qa": "project-gallery" },
        },
        [
          !_vm.readOnly
            ? _c(
                "div",
                { class: _vm.galleryItemClass },
                [
                  _c(
                    "block-editor",
                    {
                      staticClass: "gfua-gallery__placeholder",
                      attrs: { empty: true, "content-transparent": true },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prefix",
                            fn: function () {
                              return [
                                _c("block-editor-single-icon-prefix", {
                                  attrs: {
                                    icon: "plus",
                                    "icon-position": "center",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        590017230
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            "gfua-gallery__placeholder-content",
                            _vm.galleryImageClass,
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "gfua-gallery__item-content" },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "gfua-gallery__item-placeholder gfu-block-editor__media-placeholder",
                                    _vm.showVideos
                                      ? "_flexb50"
                                      : "gfu-flex__item gfu-flex__item--grow",
                                  ],
                                  attrs: {
                                    "data-qa":
                                      "gallery-settings-button:AddImage",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.openUpdateImageModal(null)
                                    },
                                  },
                                },
                                [
                                  _c("base-icon", { attrs: { name: "image" } }),
                                  _vm._v(
                                    "\n                            add image\n                        "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showVideos
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "gfua-gallery__item-placeholder gfu-block-editor__media-placeholder _flexb50",
                                      attrs: {
                                        "data-qa":
                                          "gallery-settings-button:AddVideo",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openUpdateVideoModal(null)
                                        },
                                      },
                                    },
                                    [
                                      _c("base-icon", {
                                        attrs: {
                                          name: "youtube",
                                          "icon-namespace": "brands",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                            add video\n                        "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.gallery, function (galleryItem, index) {
            return [
              _c(
                "div",
                {
                  key: galleryItem.galleryItemID,
                  class: _vm.galleryItemClass,
                  on: {
                    drop: function ($event) {
                      return _vm.handleDrop(galleryItem)
                    },
                    dragover: _vm.handleDragOver,
                    dragenter: function ($event) {
                      return _vm.handleDragEnter(galleryItem)
                    },
                    dragleave: function ($event) {
                      return _vm.handleDragLeave(galleryItem)
                    },
                  },
                },
                [
                  _c(
                    "block-editor",
                    {
                      ref: "gallery-item-" + galleryItem.galleryItemID,
                      refInFor: true,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prefix",
                            fn: function () {
                              return [
                                _c(
                                  "block-editor-draggable-prefix",
                                  {
                                    attrs: {
                                      "allow-drag": !_vm.readOnly,
                                      "drag-element-class":
                                        _vm.galleryImageClass,
                                    },
                                    on: {
                                      dragstart: function ($event) {
                                        return _vm.handleDragStart(
                                          galleryItem,
                                          $event
                                        )
                                      },
                                      dragend: _vm.handleDragEnd,
                                    },
                                  },
                                  [
                                    _vm.isImage(galleryItem)
                                      ? _c("base-icon", {
                                          attrs: {
                                            name: "image",
                                            draggable: "false",
                                          },
                                        })
                                      : _vm.isVideo(galleryItem)
                                      ? _c("base-icon", {
                                          attrs: {
                                            name: "youtube",
                                            "icon-namespace": "brands",
                                            draggable: "false",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.readOnly
                                      ? _c(
                                          "tooltip",
                                          {
                                            attrs: {
                                              draggable: "false",
                                              text: "This campaign phase is already closed. You can't edit it.",
                                            },
                                          },
                                          [
                                            _c("base-icon", {
                                              staticClass: "_mt-3",
                                              attrs: { name: "ban" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.readOnly
                                      ? _c("base-icon", {
                                          staticClass:
                                            "gfu-block-editor-prefix-icon gfu-block-editor-prefix-icon--centered",
                                          attrs: { name: "grip-lines" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "gfu-block-editor__number _mt-a",
                                        attrs: { draggable: "false" },
                                      },
                                      [_vm._v(" " + _vm._s(index + 1) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c(
                                  "dropdown-group",
                                  { attrs: { fixed: false } },
                                  [
                                    !_vm.readOnly
                                      ? _c("dropdown-link", {
                                          attrs: {
                                            icon: "trash-alt",
                                            label: "Delete",
                                            "data-qa": `gallery-item-delete-btn:${galleryItem.galleryItemID}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteGalleryItem(
                                                galleryItem
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _vm.isImage(galleryItem)
                        ? _c(
                            "div",
                            { staticClass: "gfu-block-editor__media-wrapper" },
                            [
                              _c("div", {
                                class: [
                                  "gfu-block-editor__media",
                                  _vm.galleryImageClass,
                                ],
                                style: {
                                  backgroundImage:
                                    "url(" + galleryItem.imageUrl + ")",
                                },
                                attrs: {
                                  "data-qa": `gallery-image:${galleryItem.galleryItemID}`,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openUpdateImageModal(galleryItem)
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm.isVideo(galleryItem)
                        ? _c(
                            "div",
                            { staticClass: "gfu-block-editor__media-wrapper" },
                            [
                              _c("div", {
                                class: [
                                  "gfu-block-editor__media",
                                  _vm.galleryImageClass,
                                ],
                                style: {
                                  backgroundImage:
                                    "url(" + _vm.getVideoUrl(galleryItem) + ")",
                                },
                                attrs: {
                                  "data-qa": `gallery-video:${galleryItem.galleryItemID}`,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openUpdateVideoModal(galleryItem)
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]
          }),
          _vm._v(" "),
          _vm.gallery.length > 5
            ? [
                _c(
                  "div",
                  { class: _vm.galleryItemClass },
                  [
                    _c(
                      "block-editor",
                      {
                        staticClass: "gfua-gallery__placeholder",
                        attrs: { empty: true, "content-transparent": true },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prefix",
                              fn: function () {
                                return [
                                  _c("block-editor-single-icon-prefix", {
                                    attrs: {
                                      "icon-name": "plus",
                                      "icon-position": "center",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3101132708
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: [
                              "gfua-gallery__placeholder-content",
                              _vm.galleryImageClass,
                            ],
                            attrs: { "data-qa": "gallery-settings:Image" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "gfua-gallery__item-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "gfua-gallery__item-placeholder gfu-block-editor__media-placeholder",
                                      _vm.showVideos
                                        ? "_flexb50"
                                        : "gfu-flex__item gfu-flex__item--grow",
                                    ],
                                    attrs: {
                                      "data-qa":
                                        "gallery-settings-button:AddImage",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUpdateImageModal(null)
                                      },
                                    },
                                  },
                                  [
                                    _c("base-icon", {
                                      attrs: { name: "image" },
                                    }),
                                    _vm._v(
                                      "\n                                add image\n                            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.showVideos
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "gfua-gallery__item-placeholder gfu-block-editor__media-placeholder _flexb50",
                                        attrs: {
                                          "data-qa":
                                            "gallery-settings-button:AddVideo",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openUpdateVideoModal(
                                              null
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("base-icon", {
                                          attrs: {
                                            name: "youtube",
                                            "icon-namespace": "brands",
                                          },
                                        }),
                                        _vm._v(
                                          "\n                                add video\n                            "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("update-image-modal", {
        ref: "updateImageModal",
        attrs: {
          ratio: _vm.aspectRatio,
          "upload-api-action": _vm.uploadTempImageApiAction,
        },
        on: { "upload-image": _vm.uploadImage },
      }),
      _vm._v(" "),
      _vm.showVideos
        ? _c("update-video-modal", {
            ref: "updateVideoModal",
            attrs: {
              ratio: _vm.aspectRatio,
              "upload-api-action": _vm.uploadTempImageApiAction,
            },
            on: { "upload-video-image": _vm.uploadVideoImage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }